(() => {
  const bind = async root => {
    if (root.dataset.bound || !root.dataset.builderConfig) return;
    root.dataset.bound = 'true';
    try {
      const response = await fetch(root.dataset.builderConfig);
      if (!response.ok) return;
      const config = await response.json();
      const link = root.querySelector('[data-bundle-link]');
      if (!link) return;
      const choices = config.groups.flatMap(group => group.choices);
      const part = choices.find(choice => String(choice.productId).split('/').pop() === root.dataset.productId)
        || config.components.map(c => c.fixedMirror).filter(Boolean).find(choice => String(choice.productId).split('/').pop() === root.dataset.productId);
      if (!part) return;
      const refresh = () => {
        const section = root.closest('product-info') || root.closest('section');
        const field = section?.querySelector('form[action*="/cart/add"] input[name="id"]');
        const id = field?.value || root.dataset.variantId;
        const url = new URL(link.href, location.origin); url.searchParams.set('part', id); link.href = url.pathname + url.search;
      };
      refresh(); link.hidden = false; root.querySelector('[data-bundle-note]').hidden = false;
      root.addEventListener('pointerover', refresh); root.addEventListener('focusin', refresh);
      document.addEventListener('change', refresh);
    } catch (_) { /* The compatible-parts link remains available. */ }
  };
  const scan = () => document.querySelectorAll('[data-mc-product-build]').forEach(bind);
  scan(); document.addEventListener('shopify:section:load', scan);
})();
